import React, { useContext, useEffect } from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { getDashboard, postDashboard } from "../../../api/dashboard";
import EditIcon from "../../../../assets/images/alarmIcon/edit-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchChannelLatestDataForDashboard,
} from "../../../model/async/customDashboardAsync";
import {
  isOpenLiveTrendEditPage,
} from "../../../model/slice/customDashboardSlice";
import { DashboardCSVDownload } from "../csvDownload";
import { HeaderToolButton } from "./headeToolButton";
import { useTranslation } from "react-i18next";
import localizationKeys from "../../../i18n/localizationKeys";
import { DASHBOARD_MODE } from "../constants"
import UserContext from "../../../context/UserContext";
import { LabelOutlined } from "@mui/icons-material";


export const DashboardHeaderTools = (props) => {
  const {
    currentVessel,
    mode,
    setMode,
    setIsDrawerOpen,
    setDashboards,
    selectedDashboard,
    setSelectedDashboard,
    setAddComment,
  } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userData = useContext(UserContext).user;
  const isPublic = Number(selectedDashboard?.shareLevel) === 1;
  const isOwner = selectedDashboard?.ownerId === userData.id;
  const isEditable = !isPublic || isOwner || (isPublic && Number(selectedDashboard?.isEditableByOthers) === 1); // private is always possible to edit.
  const isOpenLiveTrendEditPageFlag = useSelector(isOpenLiveTrendEditPage);

  useEffect(() => {
    if (!currentVessel?.id || mode !== DASHBOARD_MODE.DISPLAY) return;
    const latestChannelDataInterval = setInterval(() => {
      dispatch(fetchChannelLatestDataForDashboard({ vesselId: currentVessel.id }));
    }, 60 * 1000);
    return () => {
      clearInterval(latestChannelDataInterval);
    };
  }, [mode]);

  const toggleMode = (mode) => {
    setMode(mode);
    setIsDrawerOpen(false);
  };

  const handleExitEdit = async () => {
    await postDashboard(currentVessel.id, selectedDashboard);
    const newDashboards = await getDashboard(currentVessel.id);
    setDashboards(newDashboards.Data);
    setSelectedDashboard(
      newDashboards.Data.find((dashboard) => dashboard.id === selectedDashboard.id)
    );
    toggleMode(DASHBOARD_MODE.DISPLAY);
  };

  const displayHeaderToolsByMode = (mode) => {
    switch (mode) {
      case DASHBOARD_MODE.DISPLAY:
        return (
          <div style={{ height: "100%", display: "flex", alignItems: "center", padding: "0 16px", gap: "12px" }}>
            <HeaderToolButton variant="outlined" onClick={() => setAddComment(true)}>
              <LabelOutlined style={{ cursor: "pointer", marginRight: "8px" }} />
              {t(localizationKeys.DashboardAddLabelButtonText)}
            </HeaderToolButton>
            {isEditable && (
              <HeaderToolButton variant="outlined" onClick={() => toggleMode("edit")}>
                <img src={EditIcon} style={{ cursor: "pointer", marginRight: "8px" }} />
                {t(localizationKeys.DashboardEditButtonText)}
              </HeaderToolButton>
            )}
            <DashboardCSVDownload />
          </div>
        );
      case DASHBOARD_MODE.EDIT:
        return (
          !isOpenLiveTrendEditPageFlag && (
            <Box sx={{ height: "100%", display: "flex", alignItems: "center" }}>
              <HeaderToolButton
                variant="outlined"
                sx={{ margin: "0 12px" }}
                onClick={() => toggleMode(DASHBOARD_MODE.SETTINGS)}
              >
                <img src={EditIcon} style={{ cursor: "pointer", marginRight: "8px" }} />
                {t(localizationKeys.DashboardSettingsButtonText)}
              </HeaderToolButton>
              <HeaderToolButton
                variant="outlined"
                sx={{ margin: "0 12px" }}
                onClick={() => handleExitEdit()}
              >
                {t(localizationKeys.DashboardExitEditButtonText)}
              </HeaderToolButton>
            </Box>
          )
        );
      case DASHBOARD_MODE.SETTINGS:
        return <></>;
    }
  };
  return <>{displayHeaderToolsByMode(mode)}</>;
};

DashboardHeaderTools.propTypes = {
  mode: PropTypes.string,
  setMode: PropTypes.func,
  currentVessel: PropTypes.object,
  setIsDrawerOpen: PropTypes.func,
  setDashboards: PropTypes.func,
  selectedDashboard: PropTypes.object,
  setSelectedDashboard: PropTypes.func,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  setAddComment: PropTypes.func,
};
